import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AuthServerProvider } from './auth-oauth2.service';
import { AccountService } from './account.service';



@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private localStorage: LocalStorageService,
    private cookieService: CookieService,
    private accountService: AccountService,
    private authServerProvider: AuthServerProvider
  ) {
  }

  login(credentials: App.Credentials): Observable<App.Account> {
    return this.authServerProvider.login(credentials).pipe(
      tap(
        (account) => {
          this.localStorage.store('refreshTokenStartTime', Date.now());
          this.accountService.authenticate(account);
        },
        () => {
          this.logout().subscribe((): void => {
            this.router.navigate(['/auth', 'sign-in']);
          })
        }
      )
    );
  }

  logout(): Observable<void> {
    return this.authServerProvider.logout().pipe(
      catchError(() => {
        return of(null);
      }),
      tap(() => {
        this.cookieService.delete('SESSION');
        this.localStorage.clear('token');
        this.localStorage.clear('refreshTokenStartTime');
        this.localStorage.clear('currOrg');
        this.localStorage.clear('currProject');
        this.accountService.authenticate(null);
      })
    );
  }

  signUp(token: string, data: {
    firstName: string;
    lastName: string;
    password: string;
  }): Observable<null> {
    return this.http.post<null>('api/staffs/invite/userinfo', data, {
      params: {
        token
      }
    });
  }

  acceptInvitation(token: string): Observable<null> {
    return this.http.post<null>('api/staffs/invite/accept', null, {
      params: {
        token
      }
    });
  }
}
